import { gql } from "apollo-boost";
import { useQuery } from "@apollo/client";

export const TRIAL_DAYS = 30;

export type GetStripePlan = {
    getStripePlans: StripePlan[],
};

export type StripePlan = {
    id: string,
    Currency: string,
    Interval: string,
    NiceCurrency: string,
    Tiers: StripeTier[],
};

export type StripeTier = {
    id: string,
    UnitAmount: number,
    UpTo: number | null,
};

const useStripePlans = () => {
    const { data, loading } = useQuery<GetStripePlan>(GET_PLANS);
    return {
        plans: data?.getStripePlans || [],
        loading
    };
};


const GET_PLANS = gql`
    query getStripePlans {
        getStripePlans {
            id
            Currency
            NiceCurrency
            Interval
            Tiers {
                id
                UnitAmount
                UpTo
            }
        }
    }
`;

export default useStripePlans;
